import { Schoolyear } from '@teetsh/app/src/types/schoolyear';
import isAfter from 'utils/time/isAfter';
import isBefore from 'utils/time/isBefore';
import isWithinInterval from 'utils/time/isWithinInterval';

/**
 * The date is considered "within" if both minDate and maxDate are set,
 * and if the date is within the interval (inclusive). If either minDate or maxDate
 * is not set, the date is not considered within.
 */
export function isWithinSchoolyearRange(
  schoolyear: Schoolyear,
  date: Date,
): boolean {
  return (
    !!schoolyear.maxDate &&
    !!schoolyear.minDate &&
    isWithinInterval(date, {
      start: schoolyear.minDate,
      end: schoolyear.maxDate,
    })
  );
}

/**
 * The date is considered "outside" if it is either before minDate or after maxDate.
 * If both minDate and maxDate are not set, the date is not considered outside.
 */
export function isOutsideSchoolyearRange(
  schoolyear: Schoolyear,
  date: Date,
): boolean {
  const isBeforeMinDate =
    !!schoolyear.minDate && isBefore(date, schoolyear.minDate);
  const isAfterMaxDate =
    !!schoolyear.maxDate && isAfter(date, schoolyear.maxDate);

  return isBeforeMinDate || isAfterMaxDate;
}
